export default {
    maleContract : "0xdc299dc0bfee847d045f8a24184884a28c049d32",
    femaleContract:"0xfcae16a3247281a7b1dbabb8cb788810fb525031"
    // stakingContract:"0x2fDdaC6b94FEe743a8c5bE0F81373e91944d12a2"
}